// src/redux/slices/library/loan.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LoanType } from "../../../types/Library";

const initialState: LoanType = {
    idBook: "",
    idUser: "",
    loanDate: ""
};

const loanSlice = createSlice({
    name: "loan",
    initialState,
    reducers: {
        setLoanData: (state, action: PayloadAction<LoanType>) => ({
            ...state,
            ...action.payload,
        }),
        resetLoanData: () => initialState,
    },
});

export const { setLoanData, resetLoanData } = loanSlice.actions;
export default loanSlice.reducer;
